import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';

// Firebase configuration from environment variables or fallback to hardcoded values
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBMx95GDxDavPb5LOBetirxaAC-SujWfu4",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "careertrail-9aeee.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "careertrail-9aeee",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "careertrail-9aeee.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "640392289305",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:640392289305:web:07c94879e4a034c5c8de88",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-NZTJ2QLGX7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize Analytics (only in production)
export let analytics = null;
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  analytics = getAnalytics(app);
}

// NOTE: Emulator connections removed - using real Firebase services
// If you want to use emulators, make sure to start them first with:
// firebase emulators:start --only auth,firestore,storage,functions

console.log('Firebase initialized with config:', {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain
});

export default app; 